/**
 * Revisione Sistema AI — periodic re-assessment of a registered AI system.
 * Source: Marko spec §11. coreBOS-A: new small module; scheduling + reminder are native BPM.
 *
 * States: Programmata (auto-created by BPM when prossima_revisione comes due) → Conclusa.
 * On Conclusa the outcome writes back `categoria_rischio` + `prossima_revisione` onto the
 * linked ai_system — coreBOS-A BPM step, not a kernel concern (kernel reads the updated system).
 * Accumulated rows = AI Act revision history for that system ("storico delle revisioni").
 */
export const aiSystemReviewDescriptor = {
    slug: 'ai_system_review',
    kind: 'document',
    label: { singular: 'Revisione Sistema AI', plural: 'Revisioni Sistema AI' },
    table: 'ai_portal_ai_system_review',
    idStrategy: 'sha256',
    fields: [
        { name: 'data_revisione', type: 'date', label: 'Data revisione', required: true },
        { name: 'esito', type: 'text', label: 'Esito', required: true },
        // Confermato | Riclassificato | Da dismettere
        { name: 'categoria_rischio_confermata', type: 'text', label: 'Categoria di rischio confermata', required: true },
        // writes back to ai_system — Inaccettabile | Alto | Limitato | Minimo
        { name: 'prossima_revisione', type: 'date', label: 'Prossima revisione', required: true },
        // writes back to ai_system.prossima_revisione on Conclusa
        { name: 'note', type: 'text', label: 'Note' },
    ],
    relations: [
        { name: 'sistema_ai', kind: 'belongsTo', target: 'ai_system' },
        { name: 'revisore', kind: 'belongsTo', target: 'ai_user' },
    ],
    behaviors: {
        ownership: true,
        audit: true,
        documents: true,
        tenantScoped: true,
    },
    emits: ['ai_system_review.completed'],
    ui: { mode: 'generated', icon: 'FileSearchOutlined', navGroup: 'Governance', navOrder: 3 },
};
